var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z","clip-rule":"evenodd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }